import { tenderAIAPi } from './tender-ai-api';
const createUser = (user) => {
    return tenderAIAPi.post(`users/register`, user);
};
const getUsers = (companyId) => {
    const url = companyId && companyId !== 'all' ? `Users?companyId=${companyId}` : `Users`;
    return tenderAIAPi.get(url);
};
const getUserById = (userId) => {
    return tenderAIAPi.get(`users/${userId}/profile`);
};
const updateUser = (user) => {
    return tenderAIAPi.post(`users/Update`, user);
};
const disableUser = (account) => {
    return tenderAIAPi.post(`users/Disable`, account);
};
const deleteUser = (id) => {
    return tenderAIAPi.put(`users/${id}`);
};
const AccountApi = {
    createUser,
    getUsers,
    getUserById,
    updateUser,
    disableUser,
    deleteUser
};
export default AccountApi;
